import React from "react";
import { useDispatch } from "react-redux";
import RuleIcon from "@mui/icons-material/Rule";
import { ActionButton } from "components";
import { validateTable } from "store/reducers/products/tables/tables.actions";
import { validateProperty } from "store/reducers/products/properties/pl-properties.actions";
import { PropertyType } from "store/reducers/products/properties/pl-properties.types";
import { ObjectAssignedEnum } from "types/validation";
import { validateSubproperty } from "store/reducers/products/subproperties/pl-subproperties.actions";

type ValidationObjectType =
  | ObjectAssignedEnum.PROPERTY
  | ObjectAssignedEnum.RULETABLE;

interface ValidateButtonProps {
  objectType: ValidationObjectType;
  objectId: string;
  parentPropertyId?: string;
  propertyType?: PropertyType;
}

const ValidateButton: React.FC<ValidateButtonProps> = ({
  objectType,
  objectId,
  parentPropertyId = "",
  propertyType = null,
}) => {
  const dispatch = useDispatch();

  const handlePropertyClick = () => {
    if (!propertyType) {
      console.error(
        `Validation of property ${objectId} could not be performed because no property type was specified.`
      );
    }

    //Main Property
    if (propertyType === PropertyType.Main) {
      dispatch(validateProperty({ propertyId: objectId }));
    }

    //Subproperty
    if (
      propertyType === PropertyType.SubPropStd ||
      propertyType === PropertyType.SubPropCustom
    ) {
      dispatch(
        validateSubproperty({
          propertyId: objectId,
          parentId: parentPropertyId,
          propertyType: propertyType,
        })
      );
    }
  };

  const handleRuleTableClick = () => {
    dispatch(validateTable({ tableId: objectId }));
  };

  //Render button for Property validations
  if (objectType === ObjectAssignedEnum.PROPERTY) {
    return (
      <ActionButton
        tooltipText="Run all property validation checks"
        tooltipArrow
        tooltipPlacement="bottom"
        ariaLabel="Validate property"
        icon={RuleIcon}
        iconOnly
        size="medium"
        color="primary"
        onClick={handlePropertyClick}
      />
    );
  }

  //Render button for Table validation
  if (objectType === ObjectAssignedEnum.RULETABLE) {
    return (
      <ActionButton
        tooltipText="Run all table validation checks"
        tooltipArrow
        tooltipPlacement="bottom"
        ariaLabel="Validate table"
        icon={RuleIcon}
        iconOnly
        size="medium"
        color="primary"
        onClick={handleRuleTableClick}
      />
    );
  }

  //Not a supported object type for the validate button
  console.warn(`Unable to validate. Unknown objectType: ${objectType}`);

  return null;
};

export default ValidateButton;
